import { Point } from "./core/primitives"
import { Pie } from "./series"
import { Animation } from "./tools/index"

let DOMTip = (() => {
	var top = 3,
		left = 3,
		arrowtt,
		speed = 10,
		timer = 10,
		arrowWidth = 8,
		arrowStyleBefore,
		followCursor = false,
		arrowStyleAfter,
		arrowBorderWidth,
		tip,
		previousIndex,
		previousNearestSeries,
		domStylesBorderColor,
		domStylesBackgroundColor,
		arrowBorderRadius,
		endalpha = 97,
		alpha = 0,
		tt,
		ttstyle,
		h,
		animation,
		target,
		ie = typeof document !== "undefined" && document.all ? true : false,
		width

	return {
		show: function (v, w, dest, domStyle, toolTip) {
			if (toolTip) {
				tip = toolTip
				if (!toolTip.findPoint) {
					arrowWidth = 0
					followCursor = true
				}
			}
			if (!tt) {
				arrowStyleAfter = document.createElement("style")
				arrowStyleBefore = document.createElement("style")

				domStylesBorderColor = ""
				tt = document.createElement("div")
				arrowtt = document.createElement("div")

				tt.setAttribute("id", "teetip1")
				arrowtt.setAttribute("id", "teetiparrow1")
				tt.className = "teetip"
				arrowtt.className = "teetiparrow"

				tt.setAttribute("style", domStyle)
				domStylesBorderColor = tt.style.getPropertyValue("border-color")
				domStylesBackgroundColor = tt.style.getPropertyValue("background-color")

				arrowBorderWidth = tt.style.getPropertyValue("border-width")
				arrowBorderRadius = tt.style.getPropertyValue("border-radius")

				arrowBorderRadius = arrowBorderRadius.substring(0, arrowBorderRadius.length - 2)

				if (arrowBorderWidth.length == 0) arrowBorderWidth = 0
				else {
					arrowBorderWidth = arrowBorderWidth.substring(0, arrowBorderWidth.length - 2)
					arrowBorderWidth = arrowBorderWidth * 2
				}

				arrowStyleBefore.innerHTML =
					".teetiparrow{width:0;height:0;border: " +
					arrowWidth +
					"px solid;position: absolute;content: '';border-color: " +
					domStylesBorderColor +
					" transparent transparent transparent;bottom: -" +
					arrowWidth * 2 +
					"px;left: 25px;}"
				arrowStyleAfter.innerHTML =
					".teetiparrow:after{content: ' ';position: absolute;width: 0;height: 0;left: -" +
					(arrowWidth - arrowBorderWidth / 2) +
					"px;bottom: " +
					(arrowBorderWidth - (arrowWidth - 1)) +
					"px; border: " +
					(arrowWidth - arrowBorderWidth / 2) +
					"px solid;border-color: " +
					domStylesBackgroundColor +
					" transparent transparent transparent;}"
				document.head.appendChild(arrowStyleBefore)
				document.head.appendChild(arrowStyleAfter)

				document.body.appendChild(tt)
				tt.appendChild(arrowtt)
				ttstyle = tt.style
				ttstyle.opacity = 0

				// IE only:
				if (ie) ttstyle.filter = "alpha(opacity=0)"
			}

			target = dest

			ttstyle.display = "block"
			ttstyle.position = "absolute"
			tt.innerHTML = arrowtt.outerHTML + v
			ttstyle.width = w ? w + "px" : "auto"

			if (!w && ie) ttstyle.width = tt.offsetWidth

			if (tt.offsetWidth > 300) ttstyle.width = 300 + "px"
			width = tt.offsetWidth
			h = parseInt(tt.offsetHeight, 10) + top
			if (tt.timer) clearInterval(tt.timer)
			tt.timer = setInterval(() => {
				DOMTip.fade(1)
			}, timer)

			document.onmousemove = this.pos
		},

		pos: e => {
			if (tip) {
				if (!tip.findPoint) {
					arrowWidth = 0
					followCursor = true
				} else {
					arrowWidth = 8
					followCursor = false
				}

				if (target) {
					var chart = target.chart
					var chartRect = chart.chartRect
					var horizontal = chart.axes.bottom.firstSeries ? !chart.axes.bottom.firstSeries.yMandatory : false
				}
				if (chart) {
					chart.draw()
					if (chart.series.items[0] instanceof Pie || followCursor || !target) {
						var d = document.documentElement,
							u = ie ? e.clientY + d.scrollTop : e.pageY,
							l = ie ? e.clientX + d.scrollLeft : e.pageX - width / 2 - 10 - arrowWidth
						arrowStyleBefore.innerHTML =
							".teetiparrow{width:0;height:0;border: " +
							arrowWidth +
							"px solid;position: absolute;content: '';border-color: " +
							domStylesBorderColor +
							" " +
							domStylesBorderColor +
							" transparent transparent;bottom: -" +
							arrowWidth * 2 +
							"px;left: " +
							(tt.getBoundingClientRect().width - arrowWidth * 2 - arrowBorderWidth / 2) +
							"px;}"
						arrowStyleAfter.innerHTML =
							".teetiparrow:after{content: ' ';position: absolute;width: 0;height: 0;left: -" +
							(arrowWidth - arrowBorderWidth / 2) +
							"px;bottom: " +
							(arrowBorderWidth - (arrowWidth - 1)) +
							"px; border: " +
							(arrowWidth - arrowBorderWidth / 2) +
							"px solid;border-color: " +
							domStylesBackgroundColor +
							" " +
							domStylesBackgroundColor +
							" transparent transparent;}"
					} else {
						var index
						if (!horizontal)
							index = Math.round(
								chart.axes.bottom.fromSizeCalcIndex(
									e.clientX - chart.canvas.getBoundingClientRect().left - chart.axes.bottom.startPos
								)
							)
						else index = Math.round(chart.axes.left.fromPos(e.layerY))
						var point = new Point()
						var distance, minDistance
						if (e.target == chart.canvas) {
							for (var n = 0; n < chart.series.items.length; n++) {
								if (!horizontal)
									distance = Math.abs(chart.series.items[n].data.values[index] - chart.axes.left.fromPos(e.layerY))
								else
									distance = Math.abs(chart.series.items[n].data.values[index] - chart.axes.bottom.fromPos(e.layerX))
								if (n == 0) {
									minDistance = distance
									chart.series.items[n].calc(index, point)
								} else if (distance < minDistance) {
									chart.series.items[n].calc(index, point)
									minDistance = distance
								}
							}
						}
						var d = document.documentElement
						var marginTop = tt.style.marginTop.substring(0, tt.style.marginTop.length - 2)
						var marginLeft = tt.style.marginLeft.substring(0, tt.style.marginLeft.length - 2)
						var u = Math.round(
							point.y +
								window.scrollY +
								chart.canvas.getBoundingClientRect().top -
								tt.getBoundingClientRect().height -
								arrowWidth -
								marginTop +
								arrowBorderWidth / 2
						)
						var l = Math.round(
							point.x +
								window.scrollX +
								chart.canvas.getBoundingClientRect().left -
								tt.getBoundingClientRect().width / 2 -
								marginLeft -
								arrowBorderWidth / 2
						)

						if (l + width / 2 - chartRect.x > chartRect.width) {
							u = Math.round(
								point.y +
									window.scrollY +
									chart.canvas.getBoundingClientRect().top -
									tt.getBoundingClientRect().height -
									arrowWidth * 2 -
									marginTop +
									arrowBorderWidth / 2
							)
							l = Math.round(
								point.x +
									window.scrollX +
									chart.canvas.getBoundingClientRect().left -
									tt.getBoundingClientRect().width -
									marginLeft
							)
							ttstyle.borderRadius =
								arrowBorderRadius + "px " + arrowBorderRadius + "px 0px " + arrowBorderRadius + "px"
							arrowStyleBefore.innerHTML =
								".teetiparrow{width:0;height:0;border: " +
								arrowWidth +
								"px solid;position: absolute;content: '';border-color: " +
								domStylesBorderColor +
								" " +
								domStylesBorderColor +
								" transparent transparent;bottom: -" +
								arrowWidth * 2 +
								"px;left: " +
								(tt.getBoundingClientRect().width - arrowWidth * 2 - arrowBorderWidth / 2) +
								"px;}"
							arrowStyleAfter.innerHTML =
								".teetiparrow:after{content: ' ';position: absolute;width: 0;height: 0;left: -" +
								(arrowWidth - arrowBorderWidth / 2) +
								"px;bottom: " +
								(arrowBorderWidth - (arrowWidth - 1)) +
								"px; border: " +
								(arrowWidth - arrowBorderWidth / 2) +
								"px solid;border-color: " +
								domStylesBackgroundColor +
								" " +
								domStylesBackgroundColor +
								" transparent transparent;}"
						} else if (l - width / 2 < chartRect.x) {
							l = Math.round(point.x + window.scrollX + chart.canvas.getBoundingClientRect().left - marginLeft)
							u = Math.round(
								point.y +
									window.scrollY +
									chart.canvas.getBoundingClientRect().top -
									tt.getBoundingClientRect().height -
									arrowWidth * 2 -
									marginTop +
									arrowBorderWidth / 2
							)
							ttstyle.borderRadius =
								arrowBorderRadius + "px " + arrowBorderRadius + "px " + arrowBorderRadius + "px 0px"
							arrowStyleBefore.innerHTML =
								".teetiparrow{width:0;height:0;border: " +
								arrowWidth +
								"px solid;position: absolute;content: '';border-color: " +
								domStylesBorderColor +
								" transparent transparent " +
								domStylesBorderColor +
								";bottom: -" +
								arrowWidth * 2 +
								"px;left: " +
								(0 - arrowBorderWidth / 2) +
								"px;}"
							arrowStyleAfter.innerHTML =
								".teetiparrow:after{content: ' ';position: absolute;width: 0;height: 0;left: -" +
								(arrowWidth - arrowBorderWidth / 2) +
								"px;bottom: " +
								(arrowBorderWidth - (arrowWidth - 1)) +
								"px; border: " +
								(arrowWidth - arrowBorderWidth / 2) +
								"px solid;border-color: " +
								domStylesBackgroundColor +
								" transparent transparent " +
								domStylesBackgroundColor +
								";}"
						} else if (l) {
							ttstyle.borderRadius =
								arrowBorderRadius +
								"px " +
								arrowBorderRadius +
								"px " +
								arrowBorderRadius +
								"px " +
								arrowBorderRadius +
								"px"
							arrowStyleBefore.innerHTML =
								".teetiparrow{width:0;height:0;border: " +
								arrowWidth +
								"px solid;position: absolute;content: '';border-color: " +
								domStylesBorderColor +
								" transparent transparent transparent;bottom: -" +
								arrowWidth * 2 +
								"px;left: " +
								(tt.getBoundingClientRect().width / 2 - arrowWidth) +
								"px;}"
							arrowStyleAfter.innerHTML =
								".teetiparrow:after{content: ' ';position: absolute;width: 0;height: 0;left: -" +
								(arrowWidth - arrowBorderWidth / 2) +
								"px;bottom: " +
								(arrowBorderWidth - (arrowWidth - 1)) +
								"px; border: " +
								(arrowWidth - arrowBorderWidth / 2) +
								"px solid;border-color: " +
								domStylesBackgroundColor +
								" transparent transparent transparent;}"
						}
					}
					if (tip && tip.pointer.visible) {
						drawPoint()
						u -=
							tip.pointer.secondCircleRadius > tip.pointer.firstCircleRadius
								? tip.pointer.secondCircleRadius
								: tip.pointer.firstCircleRadius
					}
				} else {
					var d = document.documentElement,
						u = ie ? e.clientY + d.scrollTop : e.pageY,
						l = ie ? e.clientX + d.scrollLeft : e.pageX - width / 2 - 10 - arrowWidth
				}
			} else {
				arrowWidth = 0
				followCursor = true
				var d = document.documentElement,
					u = ie ? e.clientY + d.scrollTop : e.pageY,
					l = ie ? e.clientX + d.scrollLeft : e.pageX - width / 2 - 10 - arrowWidth
				arrowStyleBefore.innerHTML =
					".teetiparrow{width:0;height:0;border: " +
					arrowWidth +
					"px solid;position: absolute;content: '';border-color: " +
					domStylesBorderColor +
					" " +
					domStylesBorderColor +
					" transparent transparent;bottom: -" +
					arrowWidth * 2 +
					"px;left: " +
					(tt.getBoundingClientRect().width - arrowWidth * 2 - arrowBorderWidth / 2) +
					"px;}"
				arrowStyleAfter.innerHTML =
					".teetiparrow:after{content: ' ';position: absolute;width: 0;height: 0;left: -" +
					(arrowWidth - arrowBorderWidth / 2) +
					"px;bottom: " +
					(arrowBorderWidth - (arrowWidth - 1)) +
					"px; border: " +
					(arrowWidth - arrowBorderWidth / 2) +
					"px solid;border-color: " +
					domStylesBackgroundColor +
					" " +
					domStylesBackgroundColor +
					" transparent transparent;}"
			}
			if (u - h < 0) u = h
			if (l < 0) l = 0

			if (target) {
				var offsetLeft = target.offsetLeft
				var node = target
				while (node.offsetParent != null) {
					offsetLeft += node.offsetLeft
					node = node.offsetParent
				}

				if (l > offsetLeft + target.clientWidth - tt.offsetWidth - 25)
					l = offsetLeft + target.clientWidth - tt.offsetWidth - 25
			}

			// Try to hide tooltip when moving mouse outside target bounds:

			/*
		if (target) {
			if ((l>target.clientLeft) && (l<(target.clientLeft+target.clientWidth)) )
			{
			}
			else {
				Tee.DOMTip.hide();
				return;
			}
		}
		*/
			if (followCursor) {
				ttstyle.top = u - h + "px"
				ttstyle.left = l + left + "px"
			} else {
				ttstyle.top = u /*- h*/ + "px"
				ttstyle.left = l /*+ left*/ + "px"
			}

			function animatePointer(point, c) {
				var pointer = tip.pointer
				animation = new Animation(tip, f => {
					if (f < 1) {
						tip.chart.draw()
						drawPointAt(point, pointer.secondCircleRadius * f, pointer.fill, pointer.secondCircleOpacity, c)
						drawPointAt(point, pointer.firstCircleRadius * f, pointer.fill, pointer.firstCircleOpacity, c)
					}
				})
				animation.onstop = () => {
					tip.chart.draw()
					drawPointAt(point, pointer.secondCircleRadius, pointer.fill, pointer.secondCircleOpacity, c)
					drawPointAt(point, pointer.firstCircleRadius, pointer.fill, pointer.firstCircleOpacity, c)
				}
				animation.duration = pointer.animationDuration
				animation.animate()
			}
			function drawPointAt(point, size, color, opacity, c) {
				c.strokeStyle = color
				c.fillStyle = color
				c.globalAlpha = opacity
				c.lineWidth = size
				c.beginPath()
				c.ellipse(point.x, point.y, size / 2, size / 2, 0, 0, 7, false)
				c.stroke()
			}
			function drawPoint() {
				if (e.target.chart) {
					e.target.chart.draw()
					var index
					var point = new Point()
					var distance, minDistance
					var nearestSeries
					var pointer = tip.pointer
					var color = tip.pointer.fill
					if (!horizontal)
						index = Math.round(
							chart.axes.bottom.fromSizeCalcIndex(
								e.clientX - chart.canvas.getBoundingClientRect().left - chart.axes.bottom.startPos
							)
						)
					else index = Math.round(chart.axes.left.fromPos(e.layerY))
					if (e.target == chart.canvas) {
						for (var n = 0; n < chart.series.items.length; n++) {
							if (!horizontal)
								distance = Math.abs(chart.series.items[n].data.values[index] - chart.axes.left.fromPos(e.layerY))
							else distance = Math.abs(chart.series.items[n].data.values[index] - chart.axes.bottom.fromPos(e.layerX))
							if (n == 0) {
								minDistance = distance
								chart.series.items[n].calc(index, point)
								nearestSeries = chart.series.items[n]
							} else if (distance < minDistance) {
								chart.series.items[n].calc(index, point)
								minDistance = distance
								nearestSeries = chart.series.items[n]
							}
						}
					}

					var c = e.target.chart.ctx
					if (!previousNearestSeries) {
						previousNearestSeries = nearestSeries
					} else if (index != -1 && previousNearestSeries != nearestSeries) {
						previousNearestSeries = nearestSeries
						if (pointer.animationVisible) animatePointer(point, c) //here will go the animation
					}

					if ((index != -1 && !previousIndex) || index == -1) {
						previousIndex = index
					} else if (index != -1 && previousIndex != index) {
						previousIndex = index
						if (pointer.animationVisible) animatePointer(point, c) //here will go the animation
					}

					drawPointAt(point, pointer.secondCircleRadius, pointer.fill, pointer.secondCircleOpacity, c)
					drawPointAt(point, pointer.firstCircleRadius, pointer.fill, pointer.firstCircleOpacity, c)
				}
			}
		},

		fade: d => {
			var a = alpha

			if ((a !== endalpha && d === 1) || (a !== 0 && d === -1)) {
				var i = speed

				if (endalpha - a < speed && d == 1) i = endalpha - a
				else if (alpha < speed && d == -1) i = a

				alpha = a + i * d

				ttstyle.opacity = alpha * 0.01

				// IE only:
				if (ie) ttstyle.filter = "alpha(opacity=" + alpha + ")"
			} else {
				clearInterval(tt.timer)
				if (d == -1) {
					ttstyle.display = "none"
					document.onmousemove = null
				}
			}
		},

		hide: () => {
			if (tt) {
				clearInterval(tt.timer)
				tt.timer = setInterval(() => {
					DOMTip.fade(-1)
				}, timer)
				if (target && target.chart) target.chart.draw()
			}
		}
	}
})()

export { DOMTip }
